import { render, staticRenderFns } from "./global_attrs.vue?vue&type=template&id=2347056f"
import script from "./global_attrs.vue?vue&type=script&lang=js"
export * from "./global_attrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports